import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { DragHandleIcon } from './MisDragSource'
import { getServiceName, getServiceQty, getServiceToothNumber, isExecuted } from './constructorTypes'
import type { ConstructorService } from './constructorTypes'

export function SortableServiceRow({
  svc,
  onToggleExecuted,
  onDelete,
}: {
  svc: ConstructorService
  hasCoefficients?: boolean
  onToggleExecuted: () => void
  onDelete: () => void
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: svc.id })
  const style = { transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.5 : 1 }

  const qty = getServiceQty(svc)
  const unitPrice = svc.unit_price ?? svc.price ?? 0
  const total = svc.total_price ?? unitPrice * qty
  const executed = isExecuted(svc)

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className="border-b border-slate-200 align-middle hover:bg-slate-50 last:border-b-0"
    >
      <td className="border-r border-slate-200 px-1.5 py-1 text-center align-middle">
        <button
          type="button"
          className="cursor-grab text-slate-300 hover:text-slate-500"
          {...attributes}
          {...listeners}
          title="Перетащить услугу"
        >
          <DragHandleIcon className="h-3.5 w-3.5" />
        </button>
      </td>
      <td className={`border-r border-slate-200 px-2 py-1 text-xs ${executed ? 'text-slate-400 line-through' : 'text-slate-800'}`}>
        {getServiceName(svc)}
      </td>
      <td className="w-14 border-r border-slate-200 px-2 py-1 text-center text-xs text-slate-600">
        {getServiceToothNumber(svc) || '—'}
      </td>
      <td className="w-12 border-r border-slate-200 px-2 py-1 text-center text-xs text-slate-600">
        {qty}
      </td>
      <td className="w-24 border-r border-slate-200 px-2 py-1 text-right text-xs text-slate-600">
        {Number(unitPrice).toLocaleString('ru-RU')} ₽
      </td>
      <td className="w-28 border-r border-slate-200 px-2 py-1 text-right text-xs font-medium text-slate-800">
        {Number(total).toLocaleString('ru-RU')} ₽
      </td>
      <td className="w-10 border-r border-slate-200 px-1 py-1 text-center align-middle">
        <button
          type="button"
          className={`mx-auto flex h-4 w-4 items-center justify-center rounded border transition-colors ${executed ? 'border-emerald-500 bg-emerald-500 text-white' : 'border-slate-300 bg-white text-transparent hover:border-emerald-400'}`}
          onClick={onToggleExecuted}
          title="Отметить выполненным"
        >
          <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
          </svg>
        </button>
      </td>
      <td className="w-10 px-1 py-1 text-center align-middle">
        <button
          type="button"
          className="text-slate-300 hover:text-red-500"
          onClick={onDelete}
          title="Удалить"
        >
          <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </td>
    </tr>
  )
}
